<template>
  <div class="page">
    <div class="page__title">
     {{ getModuleConfig("apply_page.form_title") }}
    </div>
    <div
      class="page__desc"
      v-html="getModuleConfig('apply_page.form_desc')"
    ></div>
    <div  class="page__content" v-if="getModuleConfig('apply_page.content')" v-html="getModuleConfig('apply_page.content')"></div>

    <CouponFilters
      class="s-mb-3"
      :options="filterOptions"
      :value="filter"
      @input="handleFilterChange"
    ></CouponFilters>

    <div class="search s-space-x-2 s-mb-3" v-if="isWaltilyProvider">
      <input
        class="search__input"
        placeholder="輸入優惠券代號"
        v-model="code"
      />
      <SharedButton
        size="xs"
        variant="primary"
        class="s-btn-bg-primary"
        @click="takeCoupon"
        block
      >
        領取
      </SharedButton>
    </div>

    <div>
      <Loading v-if="showLoading" loading-message="載入中..." />
      <CouponCard
        v-else-if="!showLoading && coupons.length > 0"
        v-for="coupon in coupons"
        :key="coupon.id"
        :coupon="coupon"
        :show-code="false"
        @exchange="applyCoupon"
        :button-text="coupon.button_text"
      >
      </CouponCard>
      <CouponEmpty v-else />
      <Pagination v-model="page" :total-page="lastPage" @input="fetchCoupon" />
    </div>

    <CouponModal ref="couponModal" :coupon="selectedCoupon"/>
    <CouponModal ref="tempCouponModal" :redeem-code-bundle-id="selectedRedeemCodeBundleId" @redeemed="redeemedImmediateUsageCoupon" />
  </div>
</template>

<script>
import couponApi from "@/apis/liff/v2/coupon";
import CouponCard from "@/pages/Dashboard/Coupon/CouponCard.vue";
import CouponEmpty from "@/pages/Dashboard/Coupon/CouponEmpty.vue";
import CouponModal from "@/components/Page/Liff/CouponList/CouponModal.vue"
import Loading from "@/components/Page/Liff/Shared/Loading";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import * as consts from "@/consts";
import Pagination from '@/components/Page/Liff/Shared/Pagination'
import CouponFilters from "@/pages/Dashboard/Coupon/CouponFilters.vue";
import couponMixin from "@/mixins/liff/coupon";


export default {
  mixins: [couponMixin],
  components: { CouponCard, CouponEmpty, CouponModal, Loading, SharedButton, Pagination, CouponFilters },
  data() {
    return {
      showLoading: true,
      code: null,
      coupons: [],
      page: +this.$route.query.page || 1,
      lastPage: 1,
      selectedCoupon: {},
      selectedRedeemCodeBundleId: null,
      filter: "all",
      filterCounts: {
        all: 0,
        notTaken: 0,
        taken: 0,
      },
    };
  },
  computed: {
    isWaltilyProvider() {
      const type =
        this.$store.getters["liffModule/getConfig"](
          "member_center",
          "data_source.coupon_list"
        ) ?? "waltily";
      return type == "waltily";
    },
    filterOptions() {
      return [
        { key: "all", text: `全部 (${this.filterCounts.all})` },
        { key: "not_taken", text: `尚未領取 (${this.filterCounts.notTaken})` },
        { key: "taken", text: `已領取 (${this.filterCounts.taken})` },
      ];
    },
  },
  mounted() {
    this.fetchCoupon();
    this.fetchFilterCounts()
  },
  methods: {
    async fetchCoupon() {
      this.showLoading = true;
      if (!this.isWaltilyProvider) {
        await this.getCoupons();
      } else {
        await this.getCouponsFromBundle();
      }
      this.showLoading = false;
    },
    async getCoupons() {
      try {
        const data = await couponApi.getCouponLists({
          page: this.page,
          status: "apply",
        });
        this.coupons = data.data;
        this.lastPage = data.lastPage;
      } catch (error) {
        if (error.response.data.message) {
          this.$swal.fire({
            type: "error",
            title: "錯誤",
            text: error.response.data.message,
          });
        }
      }
      this.coupons.forEach((coupon) => {
        coupon.name = coupon?.name;
        coupon.start_at = coupon?.start_at;
        coupon.end_at = coupon?.end_at;
        coupon.button_text = coupon.apply_at ? "已領取" : "我要領取";
      });
    },
    async getCouponsFromBundle() {
      const params = {
        take_type: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.DIRECT,
        validity_period: true,
        status: this.filter,
        page: this.page,
      };

      const data = await couponApi.getRedeemCodeBundles(params);
      const redeemCodeBundles = data.data;
      this.lastPage = data.lastPage;
      redeemCodeBundles.forEach((bundle) => {
        bundle.isRedeemCodeBundle = true;
        if (bundle.already_taken) {
          bundle.button_text = "已領取";
        } else {
          bundle.button_text = bundle.can_take ? "我要領取" : "已無序號";
        }
        bundle.list_button_clickable = bundle.button_text == "我要領取";
      });
      this.coupons = redeemCodeBundles;
      const filterKey = this.toCamel(this.filter);
      this.filterCounts[filterKey] = data.total;
    },
    toCamel(s) {
      return s.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
          .replace('-', '')
          .replace('_', '');
      });
    },
    async fetchFilterCounts() {
      if (!this.isWaltilyProvider) {
        return;
      }

      try {
        const params = {
          take_type: consts.REDEEM_CODE_BUNDLE_TAKE_TYPES.DIRECT,
          validity_period: true,
        };

        const counts = await couponApi.getRedeemCodeBundleCategoryCounts(params);

        this.filterCounts = {
          all: counts.all || 0,
          notTaken: counts.not_taken || 0,
          taken: counts.taken || 0,
        };
      } catch (error) {
        console.error("Failed to fetch filter counts", error);
        this.showFail("領取失敗", error.response.data.message);
      }
    },
    // 領取優惠券
    // - 輸入優惠券代碼後，呼叫 takeCoupon 方法
    // - 選擇畫面上的優惠券領取，呼叫 applyCoupon 方法
    async takeCoupon() {
      this.showLoading = true;

      try {
        const coupon = await couponApi.takeCoupon(this.code);

        if (coupon.usage_type === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE) {
          this.selectedCoupon = coupon;
          this.$refs.couponModal.open();
          return;
        }

        this.showSuccess("領取成功，請至我的優惠券查看");
        this.code = null;
      } catch (error) {
        if (error.response?.data?.error_code == 4001) {
          this.showImmediateUsageCoupon(error.response.data.redeem_code_bundle_id);
          this.code = null;
          return;
        }

        console.log(error);
        this.showFail("查無此優惠代碼");
      } finally {
        this.showLoading = false;
      }
    },
    showImmediateUsageCoupon(redeemCodeBundleId) {
      this.selectedRedeemCodeBundleId = redeemCodeBundleId;
      this.$refs.tempCouponModal.open();
    },
    async applyCoupon(coupon) {
      if (coupon.isRedeemCodeBundle && coupon.usage_type === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE) {
        this.showImmediateUsageCoupon(coupon.id);
        return;
      }

      try {
        if (coupon.isRedeemCodeBundle) {
          await couponApi.applyCouponFromRedeemCodeBundle(coupon);
        } else {
          await couponApi.applyCoupon(coupon);
        }
        this.showSuccess("領取成功");
      } catch (error) {
        console.log(error.response.data);
        this.showFail("領取失敗", error.response.data.message);
      }
      this.fetchCoupon();
    },
    async redeemedImmediateUsageCoupon(couponId) {
      console.log("redeemedImmediateUsageCoupon", couponId);
      this.showLoading = true;
      try {
        this.selectedCoupon = await couponApi.getCoupon(couponId);
        this.$refs.couponModal.open();
        this.fetchCoupon();
      } catch (e) {
        console.error(e);
      }
      this.showLoading = false;
    },
    showSuccess(message) {
      this.$swal.fire({
        title: message,
        type: "success",
      });
    },
    showFail(title, message) {
      this.$swal.fire({
        title: title,
        text: message,
        type: "error",
      });
    },
    handleFilterChange(newFilter) {
      this.filter = newFilter;
      // when page is reset to 1, fetchCoupon will be called by the pagination watcher
      if (this.page != 1) {
        this.page = 1;
        return;
      }
      this.fetchCoupon();
    },
  },
};
</script>

<style lang="scss">
.search {
  display: flex;

  &__input {
    background: #ffffff;
    border-radius: 10px !important;
    border: 1px solid var(--liff-button-color);
    padding: 15px 12px;
    width: 80%;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;

    &::placeholder {
      letter-spacing: -0.408px;
      color: #b7b7b7;
    }

    &:focus {
      border: 1px solid var(--liff-button-color);
      outline: none;
    }
  }

  button {
    font-weight: 600;
    font-size: 15px;
    line-height: 21px;
    height: 48px;
    width: 20%;
  }
}
</style>
